const formatMoneyLong = (amount: number) => {
  const cash = Math.round(amount / 10) * 10;
  if (cash === undefined) {
    return 0;
  }
  return cash.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export default formatMoneyLong;
